import { render } from "./PredictionOutcome.vue?vue&type=template&id=1f022410&scoped=true"
import script from "./PredictionOutcome.vue?vue&type=script&lang=js"
export * from "./PredictionOutcome.vue?vue&type=script&lang=js"

import "./PredictionOutcome.vue?vue&type=style&index=0&id=1f022410&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f022410"

export default script